/* eslint no-console:0 */
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
const application = Application.start();
const minimalControllers = require.context("minimal/controllers", true, /.js$/);
const richControllers = require.context("controllers", true, /.js$/);
for (var context of [minimalControllers, richControllers]) {
  application.load(definitionsFromContext(context));
}